/**
 * List of parameterized routes in the app
 *
 * We use this for:
 * - tracking page view in TrackPageView, where we need the routes to match the
 *   current path. Allows us to track parameterized routes like `/c/:workspace` as
 *   `/c/:workspace` instead of `/c/some-workspace`
 * - generating the next path when switching workspaces in useSwitchToWorkspace
 *
 * !!! The order of routes is important. Make sure routes with dynamic parameters (like /c/:workspace) are at the end of the list.
 * !!! Otherwise, they will match before the static routes (like /c/templates or /c/user/settings)
 */
export const routes = [
  '/c/',
  '/c/2fa/:authKey',
  '/c/addons',
  '/c/admin/announcements',
  '/c/admin/assemblies',
  '/c/admin/assemblies/:id',
  '/c/admin/coupons',
  '/c/admin/dashboard',
  '/c/admin/dashboard/bi',
  '/c/admin/founder-dashboard',
  '/c/admin/invoices',
  '/c/admin/invoices/:invoice_id',
  '/c/admin/ops',
  '/c/admin/plans',
  '/c/admin/revenues',
  '/c/admin/workspace/:adminWorkspace',
  '/c/admin/workspace/:adminWorkspace/usage',
  '/c/admin/workspaces',
  '/c/admin/workspaces/:workspaceStatus',
  '/c/assemblies',
  '/c/billing',
  '/c/collaborators',
  '/c/create-new-workspace',
  '/c/create-workspace',
  '/c/forgot-password',
  '/c/login',
  '/c/onboarding/file-type',
  '/c/reset-password',
  '/c/settings',
  '/c/signup',
  '/c/template-credentials',
  '/c/templates',
  '/c/templates/new',
  '/c/user/settings',
  '/c/verify-email/:authKey',
  '/c/:workspace',
  '/c/:workspace/addons',
  '/c/:workspace/assemblies',
  '/c/:workspace/assemblies/:id',
  '/c/:workspace/billing',
  '/c/:workspace/collaborators',
  '/c/:workspace/invoices/:invoice_id',
  '/c/:workspace/invoices/convert/:invoice_id',
  '/c/:workspace/onboarding/file-type',
  '/c/:workspace/onboarding/processing',
  '/c/:workspace/onboarding/setting-up',
  '/c/:workspace/settings',
  '/c/:workspace/template-credentials',
  '/c/:workspace/template-credentials/create',
  '/c/:workspace/template-credentials/:id',
  '/c/:workspace/template-credentials/:credentialId',
  '/c/:workspace/template-credentials/create-api-credential',
  '/c/:workspace/template-credentials/edit-api-credential/:credentialId',
  '/c/:workspace/template-credentials/show-api-credential-secret/:credentialId',
  '/c/:workspace/templates',
  '/c/:workspace/templates/:id',
  '/c/:workspace/templates/new',
]
